<template lang="pug">
  include ../../../../../pug/mixins/bem
  div
    +b.poll-title--centered.H1 {{ _('Які бренди каші для дітей ви вводили?') }}
    +b.poll-checkboxes 
      +e.el(
        v-for='item in brands'
      )
        +e.input.INPUT(
          type='checkbox',
          name='brands',
          :value='item.key',
          :id='item.key'
          v-model='brand'
        )
        +e.label.LABEL(
          :for='item.key'
          
        )
          +e.text.P  {{ item.title }}
      +e.el
        +b.poll-input
          +e.input.INPUT(
            type='text',
            :disabled='isDisabled()'
            name='other'
            v-model='other'
            :placeholder='_("Вкажіть інший бренд")'
          )
    +b.poll-btn.BUTTON(
      href='',
      :class='{"is-disabled": !brand.length}'
      @click.prevent='next'
    ) {{ _('Далі') }}
  
</template>

<script>
export default {
  name: 'Brands',
  data() {
    return {
      other: '',
      brand: [],
      brands: [
        {
          title: this._('Milupa'),
          key: 'is_milupa',
        },
        {
          title: this._('Nutrilon'),
          key: 'is_nutrilon',
        },
        {
          title: this._('Каша для дорослих / приготувала сама'),
          key: 'is_handmade',
        },
        {
          title: this._('Інший бренд'),
          key: 'is_some_brand',
          need_input: true,
        },
      ]
    }
  },
  computed: {
    nested() {
      return this.brands.find(k => k.need_input).key
    },
  },
  methods: {
    isDisabled() {
      return !this.brand.find(el => el == this.nested)
    },
    next() {
      let obj = {
        current: 'Form'
      }
      this.brands.forEach(element => {
        obj[element.key] = element.need_input ? 
          this.other :
          this.brand.includes(element.key) 
      })
      if (this.brand.includes('is_milupa')) {
        obj.current = 'Promo'
      }
      this.$emit('next', obj)
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/js/shared/components/poll/steps/brands.vue